// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"payPending_wrapper__1rs55","content":"payPending_content__ztxLx","rotation":"payPending_rotation__yjLYU","tip":"payPending_tip__HnCpr"};